// extracted by mini-css-extract-plugin
export default {"centerContent":"CenterContent_centerContent__zptWr"};